<template>
    <div class="login-body py-5">
        <div class="">
            <div class="d-flex justify-content-center align-items-center">
                <div class="col-lg-4 col-md-6">
                    <div class="card shadow-sm text-center">
                        <div class="card-body px-lg-5 py-5">
                            <h5 class="font-weight-bold pb-4">Create a Moneypool Account</h5>
                            <form @submit.prevent="signupWithCredentials()">
                                <div class="form-group mb-3">
                                    <input class="form-control py-2 col-md-12" v-model="form.email" placeholder="Email Address" type="email" required autofocus>
                                </div>
                                <div class="row">
                                    <div class="col pr-0">
                                        <div class="form-group mb-3 align-items-center justify-content-center">
                                            <!-- <label for="username" class="col-md-3 text-muted"> </label> -->
                                            <input class="form-control col-md-12" v-model="form.lastname" placeholder="Lastname" type="text" required>
                                        </div>
                                    </div>
                                    <div class="col pl-1">
                                        <div class="form-group mb-3 align-items-center justify-content-center">
                                            <!-- <label for="username" class="col-md-3 text-muted"> </label> -->
                                            <input class="form-control col-md-12" v-model="form.firstname" placeholder="Firstname" type="text" required>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group mb-3 align-items-center justify-content-center">
                                    <!-- <label for="username" class="col-md-3 text-muted"> </label> -->
                                    <input class="form-control col-md-12" v-model="form.username" placeholder="Username" type="text" required>
                                </div>
                                <div class="form-group mb-3 align-items-center justify-content-center">
                                    <vue-tel-input @country-changed="getCountry($event)" v-model="form.phone" v-bind="bindProps"></vue-tel-input>
                                </div>
                                <div class="form-group mb-4 align-items-center justify-content-center">
                                    <!-- <label for="password" class="col-md-3 text-muted"> </label> -->
                                    <input class="form-control col-md-12" v-model="form.password" placeholder="Password" type="password"  required>
                                </div>
                                
                                <div class="">
                                    <div class="mb-2 p-0">
                                        <button class="btn btn-custom btn-block btn-lg" type="submit">SIGN UP </button>
                                    </div>
                                    <div class="divider my-4">
                                        <span>OR</span>
                                    </div>
                                    <div class="mb-4" style="width: 100%;">
                                        <a class="btn btn-block btn-danger  text-white"
                                            ref="signinBtn">
                                            <span class="fab fa-google" style="font-size: 15px; padding: 8px;"></span> 
                                                Sign up with Google
                                        </a>
                                    </div>
                                </div>

                            </form>
                            
                            Have an account? <router-link to="/login">Login</router-link>

                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>

</template>

<script>
export default {
    name: 'Signup',
    data() {
        return {
            form: {
                email: '',
                firstname: '',
                lastname: '',
                username: '',
                phone: '',
                country: '',
                password: ''
            },
            bindProps: {
                defaultCountry: "NG",
                disabledFetchingCountry: false,
                disabled: false,
                disabledFormatting: false,
                placeholder: "Enter a phone number",
                required: true,
                enabledCountryCode: true,
                enabledFlags: true,
                preferredCountries: ["AU", "BR"],
                onlyCountries: [],
                ignoredCountries: [],
                autocomplete: "off",
                name: "telephone",
                maxLen: 25,
                wrapperClasses: "",
                inputClasses: "",
                dropdownOptions: {
                    disabledDialCode: false
                },
                inputOptions: {
                    showDialCode: false
                }
            }
        };
    },

    beforeDestroy() {
        if (document.querySelector("meta[name=google-signin-client_id]")) {

            document.querySelector("meta[name=google-signin-client_id]").remove()
        }
    },

    mounted() {
        const meta_element = document.createElement('meta');
        meta_element.setAttribute('name', 'google-signin-client_id');
        meta_element.setAttribute('content', process.env.VUE_APP_GOOGLE_CLIENTID);
        document.head.appendChild(meta_element);
        
        window.gapi.load('auth2', () => {
            const auth2 = window.gapi.auth2.init();

            auth2.attachClickHandler(this.$refs.signinBtn, {}, googleUser => {
                this.signupWithGoogle(googleUser)
            }, error => console.log(error))
        });
    },

    methods: {
        getCountry($event) {
            this.form.country = $event.name;
        },
        async signupWithCredentials() {
            try {
                const signup = await axios.post('/auth/register', this.form);

                if (signup.status ==  200 ) {

                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Success',
                        text: 'You have signed up successfully, Proceed to login'
                    })

                    this.$router.push('/login');
                }                
            } catch (error) {
                // console.log(error.response)   
            }
            //
        },
        
        async signupWithGoogle(googleUser) {

            const profile = googleUser.getBasicProfile();
            const { Eea, wea, ofa, U3 } = profile;
            const social = {
                social_id: Eea, 
                firstname: ofa,
                lastname: wea,
                email: U3
            };

            console.log(social);

            try {
                const googleSignup = await axios.post('/auth/social/google/onboard', social);

                console.log(googleSignup)
    
                if (googleSignup.status == 200) {
    
                    const { access_token, expires_in, token_type } = googleSignup.data;
                    const headers = { Authorization: `Bearer ${access_token}`};
                    const logged_in_user = await axios.post('/auth/me', {}, { headers });
    
                    localStorage.setItem('access_token', access_token);
                    localStorage.setItem('expires_in', expires_in);
                    localStorage.setItem('token_type', token_type);
                    localStorage.setItem('user', JSON.stringify(logged_in_user.data));

                    this.$router.push('/dashboard');

                    // set axios authorization header
                    axios.defaults.headers.Authorization = `Bearer ${access_token}`;
                }            
            } catch (error) {
                // console.log(error.response)
            }
        }
    }

}
</script>

<style scoped>

.btn-social {
    font-size: 1em;
}
.divider { 
    width: 100%; 
    text-align: center; 
    border-bottom: 1px solid rgba(0,0,0,.1);
    line-height: 0.1em; 
    margin: 10px 0 20px; 
} 
.divider span { 
    background: inherit !important;
    padding: 0 10px; 
    font-weight: bold;
}

.login-body {
    background: #F4EEF6;
    height: 100%;
}
/* .card {
    background-color: #ffffffdb;
} */
@media (min-width: 768px) {
    .login-body {
        height: 100vh;
    }
}


</style>